export const beautifyPrice = (
  price?: unknown,
  useSpaces: boolean = false
): string => {
  if (price !== undefined && price !== null) {
    let formattedPrice = price.toString();
    if (useSpaces) {
      formattedPrice = formattedPrice.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }
    return useSpaces
      ? formattedPrice + "₸"
      : formattedPrice + "₸";
  } else {
    return "N/A";
  }
};